import React, { useContext } from 'react';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';
import { LbxTheme } from '../../partials';
import { LoadingScreen } from '../../components';
import { CustomizedSceen } from './CustomizedScreen'
import { StandardScreen } from './StandardScreen';
import { AppContext } from '../../store/contexts/AppContext';

export default function Personal() {

	const { 
    cmsConfiguration, 
    customerProfile, 
    userPreferences,
    webglConfigurations,
    setWebglConfigurations, 
    settings, 
    canRenderPersonalPage, 
    selectedAtmosphere, 
    showLoadingScreen, 
    setShowLoadingScreen,
    guestExpiryTime
  } = useContext(AppContext);
    
  const hasRecommendedAtmosphere = _.get(userPreferences, 'atmosphere')
  const labels = _.get(cmsConfiguration, `labels.hub-screen`, {});
  const contentSettings = _.get(cmsConfiguration, `settings`, {});
  const appSettings = {...settings, ...contentSettings};
  const loadingLabels = _.get(cmsConfiguration, `labels.loading-screen`, {});
  const cityEventsContent = _.get(cmsConfiguration, `labels.benefits-screen.city-events`)
  const shouldRenderGustUserPrompt = !!(Date.now() > guestExpiryTime) && guestExpiryTime;

  if (cityEventsContent) {
    _.set(labels, 'city-events', cityEventsContent)
  }
  

    return (
      <LbxTheme theme={selectedAtmosphere}>
        {
          showLoadingScreen ? 
            <LoadingScreen {...{
              onLoadingCompletion: () => { setShowLoadingScreen(false) }, 
              loadingConditionsComplete:canRenderPersonalPage,
              videoUrl:_.get(loadingLabels, 'videoUrl')
            }}/>
            :
            (
              hasRecommendedAtmosphere
                  ? <CustomizedSceen {...{labels, customerProfile, userPreferences, webglConfigurations, setWebglConfigurations, settings:appSettings, guestPromptRendered:shouldRenderGustUserPrompt}}/>
                  : <StandardScreen {...{labels, customerProfile, settings:appSettings, guestPromptRendered:shouldRenderGustUserPrompt}}/>
            )
        }
      </LbxTheme>
    )
}